module.exports = __webpack_public_path__ + "img/10.4fb7ed2d.jpg";